export enum CreateNoteState {
  IDLE = "IDLE", // Just selected a new patient. No recording has started yet.
  MANUAL = "MANUAL", // Manually writing note. Scribing and transcription are off.
  RECORDING = "RECORDING", // Recording is active.
  PAUSED = "PAUSED", // Recording is paused.
  COMPLETE = "COMPLETE", // Recording is complete.
}

export enum NoteType {
  MANUAL = "MANUAL",
  AI = "AI",
  UPLOAD = "UPLOAD",
}
